import { render, staticRenderFns } from "./SocialSignup.vue?vue&type=template&id=56be42ae&"
import script from "./SocialSignup.vue?vue&type=script&lang=js&"
export * from "./SocialSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports